import Vue from "vue";
import VueMeta from "vue-meta";
import VueRouter, { RouteConfig } from "vue-router";
import home from "@/modules/home/routes";
import welcome from "@/modules/welcome/routes";
import selfie from "@/modules/selfie/routes";
import document from "@/modules/document/routes";
import trn from "@/modules/trn/routes";
import finish from "@/modules/finish/routes";
import company from "@/modules/company/routes";

import middleware from "@/router/middleware/persistQueryParams";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  ssrAttribute: "data-vue-meta-server-rendered",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
});

const routes: Array<RouteConfig> = [
  ...home,
  ...welcome,
  ...selfie,
  ...document,
  ...trn,
  ...finish,
  ...company,
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(middleware);

export default router;
